import * as React from "react";
import { SVGProps } from "react";

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" {...props}>
    <circle cx={16} cy={16} r={15.3} stroke={props.color} strokeWidth={1.4} />
    <g
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      clipPath="url(#a)"
    >
      <path d="m12.167 12.166 7.667 7.667M19.834 12.166l-7.667 7.667" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M12 12h8v8h-8z" />
      </clipPath>
    </defs>
  </svg>
);
export default CloseIcon;
